import { MRT_ColumnDef } from 'mantine-react-table'
import { memo } from 'react'
import { useNavigate } from 'react-router-dom'
import ProvincePageList from 'src/containers/Province'
import { buildLocationUsersPagePath } from 'src/utils/userLocationFilter'

function ProvincePage() {
	const navigate = useNavigate()

	const handleProvinceClick = (provinceName: string) => {
		if (provinceName) {
			navigate(buildLocationUsersPagePath('province', provinceName))
		}
	}

	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'province',
			header: 'Province',
			Cell: ({ cell }) => {
				const provinceName = cell.getValue<string>()
				return provinceName ? (
					<span
						onClick={() => handleProvinceClick(provinceName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{provinceName}
					</span>
				) : (
					<span>{provinceName}</span>
				)
			},
		},
		{
			accessorKey: 'amount',
			header: 'Amount of user',
		},

		{
			accessorKey: 'province1',
			header: 'Province',
			Cell: ({ cell }) => {
				const provinceName = cell.getValue<string>()
				return provinceName ? (
					<span
						onClick={() => handleProvinceClick(provinceName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{provinceName}
					</span>
				) : (
					<span>{provinceName}</span>
				)
			},
		},
		{
			accessorKey: 'amount1',
			header: 'Amount of user',
		},

		{
			accessorKey: 'province2',
			header: 'Province',
			Cell: ({ cell }) => {
				const provinceName = cell.getValue<string>()
				return provinceName ? (
					<span
						onClick={() => handleProvinceClick(provinceName)}
						style={{
							cursor: 'pointer',
							textDecoration: 'underline',
							color: '#006B35',
						}}
					>
						{provinceName}
					</span>
				) : (
					<span>{provinceName}</span>
				)
			},
		},
		{
			accessorKey: 'amount2',
			header: 'Amount of user',
		},
	]
	const fields = [
		{
			value: 'province',
			label: 'Province',
		},
	]
	return <ProvincePageList columns={columns} fields={fields} />
}

export default memo(ProvincePage)
